import { DayNumber } from 'enums'
import { IOptionItem } from 'interfaces'
import { useTranslation } from 'react-i18next'

const useUtil = () => {
  const { t } = useTranslation()

  const getOptions = (arrays: Array<any>) => {
    return arrays.map((item) => {
      return { ...item, label: t(item.label) } as IOptionItem
    })
  }

  const getDayWithTime = (d: Date, numberDay: DayNumber) => {
    const day = d.getDay()
    const diff = d.getDate() - day + (day === 0 ? -6 : numberDay)
    return new Date(d.setDate(diff))
  }

  const getDayBetweenTime = (from: number, to: number) => {
    const getDays = (fromDay: number, toDay: number) => {
      const result = []
      for (let index = fromDay; index <= toDay; index++) {
        result.push(index)
      }
      return result
    }
    const fromDay = new Date(from).getDay()
    const toDay = new Date(to).getDay()

    if (fromDay - toDay > 0) {
      const allDay = [0, 1, 2, 3, 4, 5, 6]
      const diffDay = getDays(fromDay, toDay)
      return allDay.filter((day) => !diffDay.includes(day))
    }

    if (fromDay - toDay < 0) {
      return getDays(fromDay, toDay)
    }

    if (fromDay === toDay) return [fromDay]
  }

  return { getOptions, getDayWithTime, getDayBetweenTime }
}
export default useUtil
